import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 27 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observer } from "mobx-react";
import * as React from "react";
import rootStore from "../../../shared/stores/RootStore";
import { StoreName } from "../../../shared/stores/StoreName";
import translate from "../../i18n/translate";
import Icon, { IconColor, IconType } from "../../media/Icon";
import Alert from "../Alert";
var messageStore = rootStore.getStore(StoreName.Message);
/**
 * Message component which hide itself after 5 sec.
 */

var Message = function Message(props) {
  var remove = function remove() {
    messageStore.remove(props.id);
  };

  var message = props.message,
      id = props.id;
  return React.createElement(Alert, {
    type: message.type,
    key: id,
    count: message.count,
    title: translate(message.type),
    className: "rounded mb1",
    onClose: remove,
    copyData: message.additionalData
  }, message.text, message.additionalData && message.additionalData.map && message.additionalData.length ? " - ".concat(message.additionalData.map(function (i) {
    return i.uuid;
  }).filter(function (i) {
    return !!i;
  }).join(", ")) : "");
};

var Messages =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Messages, _React$Component);

  function Messages(props) {
    var _this;

    _classCallCheck(this, Messages);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Messages).call(this, props));
    _this.messagesEndRef = React.createRef();
    return _this;
  }

  _createClass(Messages, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.clearOnMount) {
        messageStore.clear();
      }

      this.scrollToBottom();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollToBottom();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      messageStore.clear();
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      if (this.messagesEndRef && this.messagesEndRef.current) {
        this.messagesEndRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.messages.size > 0 ? React.createElement(React.Fragment, null, React.createElement("div", {
        style: {
          maxHeight: "100px",
          overflowY: "auto"
        }
      }, messageStore.visible && Array.from(this.messages).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            message = _ref2[1];

        return React.createElement(Message, {
          key: id,
          id: id,
          message: message
        });
      }), React.createElement("div", {
        ref: this.messagesEndRef
      })), React.createElement("div", {
        className: "tac pointer mb1 fs-90 c-secondary",
        onClick: messageStore.toggleVisible
      }, React.createElement(Icon, {
        iconHeight: 15,
        iconColor: IconColor.Secondary,
        iconType: messageStore.visible ? IconType.chevronUp : IconType.chevronDown
      }), " ", React.createElement("span", {
        className: "underline"
      }, translate(messageStore.visible ? "Hide notifications" : "Show notifications")))) : null;
    }
  }, {
    key: "messages",
    get: function get() {
      return messageStore.list;
    }
  }]);

  return Messages;
}(React.Component);

Messages = __decorate([observer, __metadata("design:paramtypes", [Object])], Messages);
export default Messages;